import EventHandler from './EventHandler';
import jQuery from 'jquery';
class ShoppableImage {
    constructor(section) {
        this.bindEvents = () => {
            const this_class = this;
            this.positionElements();
            if (this.image) {
                this.events.register(this.image, 'rimg:load', function (e) {
                    return this_class.positionElements();
                });
            }
            this.events.register(this.el, 'touchend', function () {
                return this_class.clearAllActive();
            });
            for (var i = 0; i < this.points.length; i++) {
                const point = this.points[i];
                const tooltip = this.tooltips[i];
                this.events.register(point, 'click', function (e) {
                    return this_class.setActivePoint(e);
                });
                this.events.register(point, 'touchend', function (e) {
                    return this_class.setActivePoint(e);
                });
                this.events.register(point, 'mouseover', function (e) {
                    return this_class.setActivePoint(e);
                });
                this.events.register(point, 'mouseout', function (e) {
                    return this_class.closeActivePoint(e);
                });
                this.events.register(point, 'focus', function (e) {
                    return this_class.setActivePoint(e);
                });
                this.events.register(tooltip, 'touchend', function (e) {
                    return e.stopPropagation();
                });
                this.events.register(tooltip, 'mouseover', function (e) {
                    return this_class.setActivePoint(e);
                });
                this.events.register(tooltip, 'mouseout', function (e) {
                    return this_class.closeActivePoint(e);
                });
                this.events.register(tooltip, 'focus', function (e) {
                    return e.stopPropagation();
                });
            }
        };
        this.positionElements = () => {
            this.positionHotspots();
            this.positionTooltips();
        };
        this.setActivePoint = (e) => {
            e.stopPropagation();
            var target = e.currentTarget;
            var point = null; // We can reset the timer if we've re-entered the tooltip or the hotspot node
            if (this.hoverTimer !== null) {
                clearTimeout(this.hoverTimer);
                this.hoverTimer = null;
            }
            point = target.closest('[data-hotspot]');
            if (e.type === 'touchend' && point.classList.contains(this.activeClass)) {
                point.classList.remove(this.activeClass);
                return;
            }
            if (e.type === 'click' && point.classList.contains(this.activeClass)) {
                return;
            }
            if (!point.classList.contains(this.activeClass)) {
                var activeTooltip = this.el.querySelector('.'.concat(this.activeClass));
                if (activeTooltip) {
                    activeTooltip.classList.remove(this.activeClass);
                } // Reposition the tooltip in case the user has scrolled or otherwise changed
                // conditions
                this.positionTooltips();
                point.classList.add(this.activeClass);
            }
        };
        this.closeActivePoint = (e) => {
            var _this2 = this;
            var target = e.currentTarget;
            var point = null;
            point = target.closest('[data-hotspot]'); // We can clear the timer because we'll be setting a new one
            if (this.hoverTimer !== null) {
                clearTimeout(this.hoverTimer);
            } // Set a timer so we don't instantly close the tooltip on each mouse event
            // We can clear this timer if the mouse re-enters the hotspot node or the tooltip node
            // so that it doesn't close right away
            this.hoverTimer = setTimeout(function () {
                point.classList.remove(_this2.activeClass);
            }, this.tooltipDelay);
        };
        this.clearAllActive = () => {
            var activeTooltip = this.el.querySelector('.'.concat(this.activeClass));
            if (activeTooltip) {
                activeTooltip.classList.remove(this.activeClass);
            }
        };
        this.positionHotspots = () => {
            var _this3 = this;
            //  Reposition points which overflow the bounds of the image
            // this.points.forEach(function (point: {
            //   dataset: { hotspotYAxis: string; hotspotXAxis: string };
            //   getBoundingClientRect: () => any;
            //   style: { bottom: string; left: string; visibility: string };
            // }) {
            //   var ySetting = parseInt(point.dataset.hotspotYAxis, 10);
            //   var xSetting = parseInt(point.dataset.hotspotXAxis, 10);
            //   var pointBounds = point.getBoundingClientRect();
            //   var imageBounds = _this3.imageWrapper.getBoundingClientRect();
            //   var yDifference = imageBounds.height - pointBounds.height;
            //   var yPercentage = (yDifference / imageBounds.height) * ySetting;
            //   point.style.bottom = ''.concat(yPercentage?.toString(), '%');
            //   var xDifference = imageBounds.width - pointBounds.width;
            //   var xPercentage = (xDifference / imageBounds.width) * xSetting;
            //   point.style.left = ''.concat(xPercentage?.toString(), '%');
            //   point.style.visibility = 'visible';
            // });
        };
        this.positionTooltips = () => {
            var this_class = this;
            // Reposition any tooltips that are overflowing the viewport
            // We update this each time the tooltip opens, so we also
            // need to unset any 'overflow' classes or styles if conditions
            // have changed
            this.resetTooltips();
            this.tooltips.forEach(function (tooltip) {
                const parentElement = jQuery(tooltip).closest('.shoppable-image__hotspot')[0];
                if (!parentElement) {
                    return;
                }
                const elementBounds = parentElement.getBoundingClientRect();
                const style = globalThis.getComputedStyle(tooltip, null);
                const marginTop = parseInt(style.marginTop, 10) || 0;
                const marginRight = parseInt(style.marginRight, 10) || 0;
                const marginBottom = parseInt(style.marginBottom, 10) || 0;
                const marginLeft = parseInt(style.marginLeft, 10) || 0;
                const topBounds = elementBounds.top - marginTop;
                const rightBounds = elementBounds.right + marginRight;
                const bottomBounds = elementBounds.bottom + marginBottom;
                const leftBounds = elementBounds.left - marginLeft;
                if (rightBounds >= this_class.window.innerWidth) {
                    tooltip.classList.add('tooltip--overflow-right');
                    const difference = this_class.window.innerWidth - rightBounds;
                    tooltip.style.left = ''.concat(difference === null || difference === void 0 ? void 0 : difference.toString(), 'px');
                }
                if (leftBounds <= 0) {
                    tooltip.classList.add('tooltip--overflow-left');
                    const _difference = Math.abs(leftBounds);
                    tooltip.style.left = ''.concat(_difference === null || _difference === void 0 ? void 0 : _difference.toString(), 'px');
                }
                if (topBounds <= 0) {
                    // This should never happen because tooltips are always below
                    // the hotspot node, but in case there's a theme-specific case where
                    // this can happen, we'll add a class if it overflows the top of the
                    // viewport
                    tooltip.classList.add('tooltip--overflow-top');
                }
                if (bottomBounds >= this_class.window.innerHeight) {
                    tooltip.classList.add('tooltip--overflow-bottom');
                    tooltip.style.top = ''.concat(bottomBounds === null || bottomBounds === void 0 ? void 0 : bottomBounds.toString(), 'px');
                }
            });
        };
        this.onSectionBlockSelect = (block) => {
            const this_class = this;
            this.clearAllActive();
            var scrollEvent = false;
            this.windowScrollEvent = this.events.register(this.window, 'scroll', function () {
                scrollEvent = true;
                if (this_class.windowScrollTimer !== null) {
                    clearTimeout(this_class.windowScrollTimer);
                }
                this_class.windowScrollTimer = setTimeout(function () {
                    this_class.positionTooltips();
                    block.el.classList.add(this_class.activeClass);
                    this_class.windowScrollTimer = null;
                }, 200);
            });
            if (scrollEvent === false) {
                this.positionTooltips();
                block.el.classList.add(this.activeClass);
            }
        };
        this.onSectionBlockDeselect = (block) => {
            this.events.unregister(this.windowScrollEvent);
            this.windowScrollEvent = null;
            block.el.classList.remove(this.activeClass);
        };
        this.onSectionUnload = () => {
            this.events.unregisterAll();
        };
        this.el = section.el;
        this.bounds = this.el.getBoundingClientRect();
        this.imageWrapper = this.el.querySelector('[data-shoppable-image-wrapper]');
        this.image = this.el.querySelector('[data-shoppable-image-img]');
        this.points = this.el.querySelectorAll('[data-hotspot]');
        this.tooltips = this.el.querySelectorAll('[data-tooltip-wrapper]');
        this.activeClass = 'shoppable-image__hotspot--active';
        this.events = new EventHandler();
        this.window = window;
        this.hoverTimer = null;
        this.tooltipDelay = 300;
        this.windowScrollTimer = null;
        this.windowScrollEvent = null;
        this.bindEvents();
    }
    resetTooltips() {
        this.tooltips.forEach(function (tooltip) {
            tooltip.classList.remove('tooltip--overflow-top');
            tooltip.classList.remove('tooltip--overflow-right');
            tooltip.classList.remove('tooltip--overflow-bottom');
            tooltip.classList.remove('tooltip--overflow-left');
            tooltip.style.top = null;
            tooltip.style.right = null;
            tooltip.style.bottom = null;
            tooltip.style.left = null;
        });
    }
}
export default ShoppableImage;
